import { atom } from 'recoil';

export const contactSearch = atom({
  key: 'contactSearch', // unique ID (with respect to other atoms/selectors)
  default: '',
  // default value (aka initial value)
});
